import { OdataManager } from '@/api/odata/odata-manager';
import { FileDesc } from '@/api/model/interfaces';

export default class DrawingPackagesFileDescOdata extends OdataManager<FileDesc> {}
